export default __webpack_public_path__ + "static/media/Economics.6a03571f.png";